import { Component, type ErrorInfo, type ReactNode } from 'react'
import { AlertTriangle, RefreshCw } from 'lucide-react'

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'

interface ErrorBoundaryProps {
	children: ReactNode
}

interface ErrorBoundaryState {
	hasError: boolean
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
	state: ErrorBoundaryState = {
		hasError: false,
	}

	static getDerivedStateFromError(): ErrorBoundaryState {
		return { hasError: true }
	}

	componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		console.error('页面渲染异常', error, errorInfo)
	}

	private handleRefresh = () => {
		window.location.reload()
	}

	render() {
		if (this.state.hasError) {
			return (
				<div className="flex min-h-screen items-center justify-center bg-muted/30 px-4">
					<Alert className="max-w-md border-destructive/40 bg-background shadow-sm" variant="destructive">
						<AlertTriangle className="h-4 w-4" />
						<AlertTitle>页面加载失败</AlertTitle>
						<AlertDescription className="space-y-4 text-muted-foreground">
							<p>请刷新页面后重试。</p>
							<Button type="button" size="sm" onClick={this.handleRefresh}>
								<RefreshCw className="mr-2 h-4 w-4" />
								刷新页面
							</Button>
						</AlertDescription>
					</Alert>
				</div>
			)
		}

		return this.props.children
	}
}
